import { render, staticRenderFns } from "./SalePricesConsignorPrices.vue?vue&type=template&id=0092ba1e"
import script from "./SalePricesConsignorPrices.vue?vue&type=script&lang=js"
export * from "./SalePricesConsignorPrices.vue?vue&type=script&lang=js"
import style0 from "./SalePricesConsignorPrices.vue?vue&type=style&index=0&id=0092ba1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports